// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "MapLocationInfo-module--wrapper--ctWU9";
export var title = "MapLocationInfo-module--title--V0hn-";
export var linkToGoogleMaps = "MapLocationInfo-module--linkToGoogleMaps--Rfz-h";
export var address = "MapLocationInfo-module--address--0TULU";
export var phone = "MapLocationInfo-module--phone--wEEsd";
export var link = "MapLocationInfo-module--link---dG0T";